let env = 'production'

if (document.location.hostname.indexOf("localhost") !== -1) {
  env = 'local'
}

if (document.location.hostname.indexOf("vibraenergia-dev.pagdeal.com.br") !== -1 ||
  document.location.hostname.indexOf("vibraenergia-dev-local.pagdeal.com.br") !== -1) {
  env = 'development'
}


export default env